import React, { Component } from 'react';
import { getCampusPay, userBindCampusPay } from './service'
import { Toast, Form, Input, Button, Modal, Dialog, Space, SpinLoading, } from 'antd-mobile'
import './index.scss';
class cardBinding extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            verifyIdName: null,
            cvvName: null,
            cvvNameTwo: null,
            rechargeMoney: null,
            userId: null,
            projectId: null,
            CampusPayInformation: {},
            loginCode: null,
            accountId: null,
            isLoading: true,
            phoneSystem: null,
        }
    }
    componentDidMount() {
        document.title = ""
        let search = window.location.search.slice(1)
        let params = search.split('&')
        var theRequest = new Object()
        for (let i = 0; i < params.length; i++) {
            theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
        }
        const script = document.createElement('script');
        script.src = 'https://appx/web-view.min.js';
        document.head.appendChild(script);
        this.setState({
            projectId: theRequest.projectId,
            rechargeMoney: theRequest.rechargeMoney,
            userId: theRequest.userId,
            payWay: theRequest.payWay,
            telPhone: theRequest.telPhone,
            loginCode: theRequest.loginCode,
            accountId: theRequest.accountId,
            phoneSystem: theRequest.phoneSystem,
        }, () => {
            this.getCampusPayVerify()
        })
    }
    getCampusPayVerify = () => {
        let params = {
            projectId: this.state.projectId,
            userId: this.state.userId,
            loginCode: this.state.loginCode,
            accountId: this.state.accountId,
        }
        if (this.state.phoneSystem) {
            params.phoneSystem = this.state.phoneSystem;
        }
        getCampusPay(params).then(res => {
            if (res.errorCode == 0) {
                this.setState({
                    CampusPayInformation: res.data,
                    isLoading: false
                })
                document.title = res.data.organizationName + '绑定'
                if (window && window?.my) {
                    window.my.postMessage({'sendToMiniProgram': document.title});
                }
            } else {
                Toast.show({
                    content: res.errorMessage,
                    position: 'bottom',
                })
                this.setState({
                    isLoading: false
                })
            }
        })
    }
    onChangeCardBinding = (value) => {
        let { CampusPayInformation, userId, projectId, rechargeMoney, telPhone, loginCode, payWay, accountId, phoneSystem } = this.state
        let { verifyIdName, cvvName, cvvNameTwo } = value
        let params = {
            verificationAccount: verifyIdName,
            verificationPassword: cvvName,
            verificationPasswordTwo: cvvNameTwo ? cvvNameTwo : '',
            userId,
            projectId,
            loginCode,
            accountId,
        }
        if (phoneSystem) {
            params.phoneSystem = phoneSystem;
        }
        userBindCampusPay(params).then(res => {
            if (res.errorCode == 0) {
                Toast.show({
                    content: '绑定成功',
                    position: 'bottom',
                })
                setTimeout(() => {
                    this.props.history.push('/cardRechargeInfo?rechargeMoney='
                        + rechargeMoney + '&userId=' + userId + '&projectId=' + projectId +
                        '&organizationName=' + CampusPayInformation.organizationName + '&telPhone=' + telPhone
                        + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
                }, 100);
            } else if (res.errorCode == 67) {
                Toast.show({
                    content: res.errorMessage,
                    position: 'bottom',
                })
                setTimeout(() => {
                    this.props.history.push('/cardRechargeInfo?rechargeMoney=' + rechargeMoney +
                        '&userId=' + userId + '&projectId=' + projectId + '&organizationName=' +
                        CampusPayInformation.organizationName + '&telPhone=' + telPhone
                        + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
                }, 1000);
            } else {
                Toast.show({
                    content: res.errorMessage,
                    position: 'bottom',
                })
            }
        })

    }
    render() {
        const onSubmit = (value) => {
            Dialog.confirm({
                title: "提示",
                content: '是否绑定当前账号',
                onConfirm: async () => {
                    await this.onChangeCardBinding(value)
                    return true
                },
            })
        }
        const { CampusPayInformation } = this.state
        const cvvNameBlur = (e) => {
            let value = e.target.value
            this.setState({
                verifyIdName: value
            })

        }
        const verifyIdNameBlur = (e) => {
            let value = e.target.value
            this.setState({
                cvvName: value
            })
        }
        return (
            <>
                {!this.state.isLoading ?
                    <div className="card-recharge-page">
                        <Form layout='horizontal'
                            onFinish={onSubmit}
                            footer={
                                <Button block type='submit' color='primary' disabled={!this.state.verifyIdName && !this.state.cvvName} style={{
                                    background: !this.state.verifyIdName && !this.state.cvvName ? '#D6D6D6' : '#5ABDFC'
                                }} size='large'> 确定 </Button>

                            }
                        >
                            <Form.Item label={CampusPayInformation.verifyIdName + '：'} name='verifyIdName'>
                                <Input style={{ '--text-align': 'right' }} onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,’’)" onBlur={verifyIdNameBlur} placeholder={CampusPayInformation.verifyIdPrompt} clearable />
                            </Form.Item>
                            {
                                CampusPayInformation.cvvName ?
                                    <Form.Item label={CampusPayInformation.cvvName + '：'} name='cvvName'>
                                        <Input style={{ '--text-align': 'right' }} onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,’’)" type='password' onBlur={cvvNameBlur} placeholder={CampusPayInformation.cvvPrompt} clearable />
                                    </Form.Item>
                                    : null
                            }
                            {
                                CampusPayInformation.cvvNameTwo ?
                                    <Form.Item label={CampusPayInformation.cvvNameTwo + '：'} name='cvvNameTwo'>
                                        <Input style={{ '--text-align': 'right' }} onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,’’)" onBlur={cvvNameBlur} placeholder={CampusPayInformation.cvvPromptTwo} clearable />
                                    </Form.Item>
                                    : null
                            }
                            {/*verificationPasswordTwo*/}
                            <Form.Header>
                                <div className="card-recharge-footer">
                                    <span className="footer-babel">温馨提示：</span>
                                    <p>{CampusPayInformation.remark}</p>
                                </div>
                            </Form.Header>
                            <span></span>
                        </Form>

                    </div>
                    :
                    <div className="page-loading">
                        <Space direction='horizontal' wrap block style={{ '--gap': '16px' }}>
                            <SpinLoading color='primary' />
                        </Space>
                    </div>

                }
            </>
        );
    }
}

export default cardBinding;
